<!-- [팝업] 진료과 선택 -->
<template>
  <b-modal
    v-model="showMediDeptSelect"
    cancel-variant="outline-secondary"
    centered
    ok-title="적용"
    cancel-title="취소"
    size="lg"
    title="진료과 선택"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row
      v-if="!isBlockAll"
      class="mt-25"
      style="border-bottom: 1px solid #ebe9f1;"
    >
      <b-col
        cols="12"
      >
        <b-form-checkbox
          v-model="selectAll"
          class="mb-1"
          style="width: 120px"
          @change="changeSelectAll()"
        >
          전체 진료과
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col
        cols="12"
      >
        <b-form-checkbox-group
          v-model="selects"
          value-field="code"
          text-field="label"
          :disabled="selectAll"
        >
          <b-form-checkbox
            v-for="dept in codes.hcpMedicalDept"
            :key="dept.code"
            :value="dept.code"
            class="mb-25 mr-3"
            style="width: 120px"
          >
            {{ dept.label }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import { ref, watch, onMounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
  },

  props: {
    showMediDeptSelect: {
      type: Boolean,
      required: true,
    },
    selectedValue: {
      type: String,
      required: false,
      default: null,
    },
    isBlockAll: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props, { emit }) {
    onMounted(() => {
      fetchCodes()
    })

    watch(
      () => props.showMediDeptSelect,
      newVal => {
        if (newVal) {
          selects.value = []
          selectAll.value = false

          if (props.selectedValue && props.selectedValue.length > 0) {
            if (props.selectedValue.toString() === '0') selectAll.value = true
            else selects.value = props.selectedValue.split(',').map(Number)
          }
        }
      },
    )

    const toast = useToast()
    const selects = ref([])
    const selectAll = ref(false)

    // Set Codes
    const codes = ref({
      hcpMedicalDept: [],
    })

    const fetchCodes = () => {
      axios.get('/fa/medi-dept-select/codes')
        .then(rs => {
          const {
            hcpMedicalDept,
          } = rs.data
          codes.value.hcpMedicalDept = hcpMedicalDept
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: '코드 데이터를 불러오는데 실패하였습니다.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
    // Set Codes End.

    const changeSelectAll = () => {
      if (selectAll.value) {
        selects.value = []
      }
    }

    const close = () => {
      emit('close')
    }

    const submit = () => {
      if (!selectAll.value && selects.value.length === 0) {
        toast({
          component: ToastificationContent,
          props: {
            title: '진료과를 한 개 이상 선택하세요',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      const retVal = []

      if (selectAll.value) {
        retVal.push({ code: '0', label: '전체 진료과' })
      } else {
        const filts = codes.value.hcpMedicalDept.filter(el => selects.value.indexOf(el.code) > -1)

        if (filts.length) {
          filts.forEach(el => {
            retVal.push(el)
          })
        }
      }

      emit('close', retVal)
    }

    return {
      codes,
      close,
      submit,
      selects,
      selectAll,
      changeSelectAll,
    }
  },
}
</script>
